(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
    }

    connectedCallback() {
      this.details.addEventListener('toggle', this.onToggle.bind(this));
    }

    onToggle() {
      if (this.details.open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }

    disconnectedCallback() {
      document.body.style.overflow = '';
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
  } catch(e) { console.error(e); }
})();

})();
